export const getCompetitionsTables = state => state.competitionsTables;
export const getMatchStat = state => id => state.matchStats.data[id]
